import React, { Suspense, useState, useTransition } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import * as AppClasses from './styles.module.scss';

export const LoadingComponent = () => (
  <div className={ AppClasses.loader }>
    <Loader active inline />
  </div>
);

const AsyncRoute = ({ component: Component, ...rest }) => {
  const [isPending, startTransition] = useTransition();
  const [mounted, setMounted] = useState(false);

  // Use startTransition to avoid suspension during synchronous updates
  React.useEffect(() => {
    startTransition(() => {
      setMounted(true);
    });
  }, []);

  return (
    <Route
      { ...rest }
      render={
        (props) => (
          <Suspense fallback={ <LoadingComponent /> }>
            { mounted && <Component { ...props } /> }
          </Suspense>
        )
      }
    />
  );
};

AsyncRoute.propTypes = {
  component: PropTypes.func.isRequired
};

export default AsyncRoute;
